import { inject, reactive } from 'vue'

import AuthLoginRegisterComponent from '@/components/auth/blocks/login-register/login-register.vue'
import AuthLoginComponent from '@/components/auth/blocks/login/login.vue'

export default {
  name: 'AuthLoginRegisterRedirectView',
  props: {
    config: {
      type: Object,
      required: false,
      default: null,
    },
    redirect: {
      type: String,
      required: false,
      default: null,
    },
    defaultTab: {
      type: String,
      required: false,
      default: 'login',
    },
    justLogin: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    AuthLoginRegisterComponent,
    AuthLoginComponent,
  },
  setup (props) {
    const config = { ...inject('config'), ...props.config };

    const authProvider = inject('authProvider')

    const state = reactive({
      showNotification: false,
      notification: null,
    })

    const calculateRedirect = (redirect) => {
      try {
        new URL(redirect);
        return redirect
      } catch (err) {
        let trimmed = redirect.trim();
        if (trimmed.indexOf('/') === 0) {
          return trimmed.slice(1);
        }
        return window.location.origin + '/' + trimmed;
      }
    }

    const handleResponse = async (response) => {
      if (response.status === 'error' || response.success === false) {
        state.showNotification = true
        state.notification = response.data.message ||
          response.data.data.message || response.data.data
      }
      else {
        state.notification = 'Successful Login. Redirecting...';
        if (props.redirect) {
          window.location.href = calculateRedirect(props.redirect);
        } else if (response.data.data.redirect_to) {
          window.location.href = calculateRedirect(response.data.data.redirect_to);
        } else {
          window.location.reload();
        }
      }
    }

    const login = async (data) => {
      state.showNotification = true
      state.notification = 'Validating Credentials...'

      const {
        username,
        password,
      } = data

      const response = await authProvider().login(username, password, config)
      handleResponse(response)
    }

    const register = async (data) => {
      state.showNotification = true
      state.notification = 'Creating Account...'

      const {
        firstname,
        lastname,
        email,
        username,
        password,
        confirm,
      } = data

      const response = await authProvider().register(firstname, lastname, email,
        username, password, confirm, config)
      handleResponse(response)
    }

    const clearNotification = async => state.showNotification = false

    return {
      login,
      register,
      clearNotification,
      state
    };
  },
};
